// extracted by mini-css-extract-plugin
module.exports = {"title":"title__26az5","form":"form__2hvka","textarea":"textarea__og7sb","modal":"modal__3nA6O"};